module.exports = __webpack_public_path__ + "static/img/jp1-5.450da4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jp1-5.png
// module id = 917
// module chunks = 0